import request from "@/utils/request"

export const uploadMinioUrl = "https://srnz.net:8701/common/uploadMinio";
// export const uploadMinioUrl = "http://8.138.189.223:8701/common/uploadMinio";

// 获取微信access_token
export function getAccessToken(query) {
    return request({
        url: '/api-wx/cgi-bin/token',
        method: 'get',
        params: query
    });
}

// 创建小程序二维码
export function createQrCode(query, data) {
    return request({
        url: '/api-wx/wxa/getwxacodeunlimit',
        method: 'post',
        params: query,
        data: data,
        responseType: 'blob'
    });
}

// 注册
export function register(data) {
    return request({
        url: '/api-nz/nz/user/register',
        headers: {
            isToken: false,
        },
        method: 'post',
        data: data
    })
}

// 发送邮箱验证码
export function sendEmailCode(data) {
    return request({
        url: '/api-nz/nz/sendEmailCode',
        headers: {
            isToken: false,
        },
        method: 'get',
        params: data
    })
}

// 重置密码
export function resetPassword(data) {
    return request({
        url: '/api-nz/nz/user/resetPassword',
        headers: {
            isToken: false,
        },
        method: 'put',
        data: data
    })
}

// 登录
export function login(data) {
    return request({
        url: '/api-nz/nz/login',
        headers: {
            isToken: false,
            repeatSubmit: false
        },
        method: 'post',
        data: data,
    });
}

// 获取统计数据
export function getStatData(data) {
    return request({
        url: '/api-nz/nz/common/getStatData',
        headers: {
            isToken: false,
            repeatSubmit: false
        },
        method: 'get',
        data: data,
    });
}

// 退出登录
export function logout() {
    return request({
        url: '/api-nz/logout',
        method: 'post'
    })
}

// 绑定信息
export function bindInfo(data) {
    return request({
        url: '/api-nz/nz/bindInfo',
        headers: {
            isToken: false,
        },
        method: 'put',
        data: data,
    });
}

// 更新扫码状态
export function updateScanCodeStatus(data) {
    return request({
        url: '/api-nz/nz/user/updateScanCodeStatus',
        headers: {
            isToken: false,
        },
        method: 'post',
        data: data,
    });
}

// 获取扫码状态
export function getScanCodeStatus(query) {
    return request({
        url: '/api-nz/nz/user/getScanCodeStatus',
        headers: {
            isToken: false,
        },
        method: 'get',
        params: query,
    });
}

// 获取微信服务access_token
export function getWxServeAccessToken(query) {
    return request({
        url: '/api-nz/wxServe/getAccessToken',
        method: 'get',
        params: query,
    });
}

// 创建订单
export function createOrder(data) {
    return request({
        url: '/api-nz/nz/userPayOrder/create',
        method: 'post',
        data: data,
    });
}

// 激活支付
export function activePay(data) {
    return request({
        url: '/api-nz/pay/activePay',
        method: 'post',
        data: data,
    });
}

// 查询订单
export function orderQuery(query) {
    return request({
        url: '/api-nz/pay/orderQuery',
        method: 'get',
        params: query,
    });
}

// 获取支付配置
export function appPayConfig(query) {
    return request({
        url: '/api-nz/pay/appPayConfig',
        method: 'get',
        params: query,
    });
}

// 获取用户信息
export function getUserInfo(query) {
    return request({
        url: '/api-nz/nz/getUserInfo',
        method: 'get',
        params: query,
    });
}

// 获取区域列表
export function getAreaList(query) {
    return request({
        url: '/api-nz/nz/area/list',
        method: 'get',
        params: query,
    });
}

// 获取试卷列表
export function getPaperList(query) {
    return request({
        url: '/api-nz/nz/paper/list',
        method: 'get',
        params: query,
    });
}

// 获取题目列表
export function getQuestionList(query) {
    return request({
        url: '/api-nz/nz/question/list',
        method: 'get',
        params: query,
    });
}

// 获取素材列表
export function getMaterialList(query) {
    return request({
        url: '/api-nz/nz/material/list',
        method: 'get',
        params: query,
    });
}

// 获取答案列表
export function getAnswerList(query) {
    return request({
        url: '/api-nz/nz/answer/list',
        method: 'get',
        params: query,
    });
}

// 获取收藏试卷列表
export function getCollectPaperList(query) {
    return request({
        url: '/api-nz/nz/paper/collectList',
        method: 'get',
        params: query,
    });
}

// 获取用户答案列表
export function getUserAnswerList(query) {
    return request({
        url: '/api-nz/nz/userAnswer/list',
        method: 'get',
        params: query
    });
}

// 获取用户补充答案列表
export function getUserAddAnswerList(query) {
    return request({
        url: '/api-nz/nz/userAddAnswer/list',
        method: 'get',
        params: query,
    });
}

// 获取用户评论列表
export function getUserCommentList(query) {
    return request({
        url: '/api-nz/nz/userComment/list',
        method: 'get',
        params: query,
    });
}

// 获取社区评论列表
export function getUserCommentCommunityList(query) {
    return request({
        url: '/api-nz/nz/userComment/community/list',
        method: 'get',
        params: query,
    });
}

// 获取用户笔记列表
export function getUserNoteList(query) {
    return request({
        url: '/api-nz/nz/userNote/list',
        method: 'get',
        params: query,
    });
}

// 获取目标对象操作状态
export function getTargetsActionStatus(query) {
    return request({
        url: '/api-nz/nz/userAction/getTargetsActionStatus',
        method: 'get',
        params: query,
    });
}

// 执行操作
export function doAction(data) {
    return request({
        url: '/api-nz/nz/userAction',
        method: 'post',
        data: data,
    });
}

// 获取公告列表
export function getNoticeList(query) {
    return request({
        url: '/api-nz/nz/notice/list',
        method: 'get',
        params: query,
    });
}

// 获取会员版本套餐列表
export function getVersionMealList(query) {
    return request({
        url: '/api-nz/nz/versionMeal/list',
        method: 'get',
        params: query,
    });
}

// 获取ocr
export function getOcr(query) {
    return request({
        url: '/api-nz/common/ocr',
        method: 'get',
        params: query,
    });
}

// 获取社区文章列表
export function getArticleList(query) {
    return request({
        url: '/api-nz/nz/article/community/list',
        method: 'get',
        params: query,
    });
}

// 获取文章草稿箱列表
export function getArtileDraftList(query) {
    return request({
        url: '/api-nz/nz/articleDraft/list',
        method: 'get',
        params: query,
    });
}

// 获取标签列表
export function getTagList(query) {
    return request({
        url: '/api-nz/nz/tag/list',
        method: 'get',
        params: query,
    });
}

// 新增用户答案
export function insertUserAnswer(data) {
    return request({
        url: '/api-nz/nz/userAnswer',
        method: 'post',
        data: data,
    });
}

// 新增用户补充答案
export function insertUserAddAnswer(data) {
    return request({
        url: '/api-nz/nz/userAddAnswer',
        method: 'post',
        data: data,
    });
}

// 新增用户评论
export function insertUserComment(data) {
    return request({
        url: '/api-nz/nz/userComment',
        method: 'post',
        data: data,
    });
}

// 新增用户笔记
export function insertUserNote(data) {
    return request({
        url: '/api-nz/nz/userNote',
        method: 'post',
        data: data,
    });
}

// 新增文章草稿
export function insertArticleDraft(data) {
    return request({
        url: '/api-nz/nz/articleDraft',
        method: 'post',
        data: data,
    });
}

// 更新文章草稿
export function updateArticleDraft(data) {
    return request({
        url: '/api-nz/nz/articleDraft',
        method: 'put',
        data: data,
    });
}

// 新增文章
export function insertArticle(data) {
    return request({
        url: '/api-nz/nz/article',
        method: 'post',
        data: data,
    });
}

// 新增举报
export function insertReport(data) {
    return request({
        url: '/api-nz/nz/report',
        method: 'post',
        data: data,
    });
}

// 更新用户
export function updateUser(data) {
    return request({
        url: '/api-nz/nz/user',
        method: 'put',
        data: data,
    });
}

// 删除用户答案
export function deleteUserAnswer(ids) {
    return request({
        url: `/api-nz/nz/userAnswer/${ids}`,
        method: 'delete'
    });
}

// 删除用户评论
export function deleteUserComment(ids) {
    return request({
        url: `/api-nz/nz/userComment/${ids}`,
        method: 'delete'
    });
}

// 删除用户笔记
export function deleteUserNote(ids) {
    return request({
        url: `/api-nz/nz/userNote/${ids}`,
        method: 'delete'
    });
}

// 删除文章草稿箱
export function deleteArticleDraft(ids) {
    return request({
        url: `/api-nz/nz/articleDraft/${ids}`,
        method: 'delete'
    });
}

